import one from '../assets/png/arctools.png'
import two from '../assets/png/carvaly.png'
import three from '../assets/png/vbot.png'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Tools Manfucturing',
        projectDesc: 'A full-stack website to purchase tools, including admin panel, users can purchase tools, update profiles & admin will be able to add products & track user activity. A fully functional authentication system has been implemented with a secure payment gateway.',
        tags: ['ReactJS', 'MongoDB', 'ExpressJS', 'Stripe'],
        code: 'https://github.com/rijonshahariar/tools-manufacturer-website',
        demo: 'https://arctoolsbd.web.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'Car Warehouse',
        projectDesc: 'A car warehouse management website. Where inventory of cars can be updated by any valid user. Any user can add, delete or update car. Firebase has been used to authenticate the user. MongoDB used to save and load data.',
        tags: ['ReactJS', 'MongoDB', 'ExpressJS', 'Firebase'],
        code: 'https://github.com/rijonshahariar/car-warehouse-website',
        demo: 'https://carvaly-d931e.web.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Virtual Bot',
        projectDesc: 'Simple virtual robot that can interact with users. It can reply users input by using if-else statement. It has both text and voice output system.',
        tags: ['HTML', 'CSS', 'Javascript'],
        code: 'https://github.com/rijonshahariar/virtrobobd',
        demo: 'https://rubyvirtualbot.herokuapp.com/',
        image: three
    },
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/